// removed by extract-text-webpack-plugin
module.exports = {"logo":"_1P8W9acEu3FgdIrpdihzU5"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/styles.scss
// module id = 623
// module chunks = 11